export default __webpack_public_path__ + "static/media/juegoregistro_instrucciones.068cfcb7.png";